import React from 'react'
import { t } from "i18next";
import NumberFormat from 'react-number-format';
import QuantityButtons from './QuantityButtons';


function ProductDetailsRows({ product, itemsCount, addItemToCart, removeItemFromCart, invalidProductAmount }) {

    return (
        <div>
            <div role="application"
                aria-roledescription={t("price")}
                aria-label={`${t("price")} ${product.productPriceAfterDiscount} ${product.currencyCode ? product.currencyCode.replace("ILS", "₪") : product.currencyCode}`}
                className="d-flex justify-content-between pb-4 border-underline-mobile"
            >
                <span>{t("price")}</span>
                <NumberFormat
                    value={product.productPriceAfterDiscount}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={product.currencyCode ? product.currencyCode.replace("ILS", "₪") : product.currencyCode}
                />
            </div>
            <div className="quantity-btns pb-3 pt-1 border-underline-mobile">
                <span className="quantity">{t("quantity")}</span>
                <QuantityButtons
                    product={product}
                    itemsCount={itemsCount}
                    addItemToCart={addItemToCart}
                    removeItemFromCart={removeItemFromCart}
                />
            </div>
            {invalidProductAmount && <span role="alert" autoFocus className="text-danger bold d-flex justify-content-end">{t("selectQuantity")}</span>}
            <div
                role="application"
                aria-roledescription={t("price")}
                aria-label={`${t("total")} ${(product.productPriceAfterDiscount * itemsCount) + (product.currencyCode ? product.currencyCode.replace("ILS", "₪") : product.currencyCode)}`}
                className="d-flex justify-content-between total-price pb-3 border-underline-mobile">
                <span>{t("total")}</span>
                <NumberFormat className="prod-prc"
                    value={(product.productPriceAfterDiscount * itemsCount).toFixed(2)}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={product.currencyCode ? product.currencyCode.replace("ILS", "₪") : product.currencyCode}
                />
            </div>
        </div>
    )
}

export default ProductDetailsRows